module.exports = __webpack_public_path__ + "7461557cdf03dc47971758b8de8cd533.png";